import { useEffect, useRef, useState } from 'react';
import { ChevronsRight } from 'lucide-react';

/**
 * Horizontal-scroll wrapper for wide data tables.
 * On small screens it shows a subtle "Deslize" hint whenever the table is
 * wider than the viewport and the user has not scrolled yet. The hint hides
 * automatically once the user scrolls sideways or if there is no overflow.
 */
export function TableScroll({ children, style }) {
  const ref = useRef(null);
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const check = () => {
      const overflowing = el.scrollWidth > el.clientWidth + 4;
      const atStart = el.scrollLeft <= 2;
      setShowHint(overflowing && atStart);
    };

    check();
    el.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    // Re-check after fonts/layout settle (tables often reflow after data load).
    const t = setTimeout(check, 400);

    return () => {
      el.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      clearTimeout(t);
    };
  }, []);

  return (
    <div className="table-scroll-wrap" style={style}>
      <div className="table-scroll" ref={ref} data-testid="table-scroll">
        {children}
      </div>
      {showHint && (
        <div className="table-scroll-hint" aria-hidden="true" data-testid="table-scroll-hint">
          <span>Deslize</span>
          <ChevronsRight size={13} />
        </div>
      )}
    </div>
  );
}
